<template lang="pug">
  v-menu(
      v-model="menu",
      :close-on-content-click="false",
      :nudge-right="40",
      transition="scale-transition",
      offset-y,
      min-width="290px",
    )
    template(v-slot:activator="{ on }")
      v-text-field(
        v-model="date",
        :label="label",
        :prepend-icon="icon",
        readonly,
        v-on="on"
        :disabled="disabled",
        :errors="errors",
      )
    v-date-picker(
      v-model="date",
      @input="menu = false",
      :min="min",
      :max="max",
      :disabled="disabled",
      @change="$emit('change', $event)"
    )
</template>
<script>
export default {
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Date'
    },
    icon: {
      type: String,
      default: null
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      date: this.value
    }
  },
  watch: {
    date: function(n,o) {
      this.$emit('input', this.date)
    }
  }
}
</script>